import React, { FC } from "react";
import { Button, TButtonProps } from "kanopi-components/Button";
import { SIZE as BUTTON_SIZE } from "baseui/button";
import { useAPI } from "kw/api/useAPI";
import { toaster } from "kanopi-components/ToastContainer";
import { QuoteState } from "kw/api/zeus";

type TCreateRenewalButton = {
  policyId: string;
  fetchPolicy?: (id: string) => void;
} & TButtonProps;

export const CreateRenewalButton: FC<TCreateRenewalButton> = ({
  policyId,
  fetchPolicy,
  ...buttonProps
}) => {
  const { mutation } = useAPI();
  const createRenewal = () => {
    mutation(
      {
        createRenewalQuote: [
          {
            input: {
              policyId,
            },
          },
          {
            id: true,
            quote: {
              state: true,
            },
            policy: {
              id: true,
            },
          },
        ],
      },
      (response: {
        createRenewalQuote: {
          policy: { id: string };
          quote: { state: QuoteState };
        };
      }) => {
        fetchPolicy(policyId);
      }
    );
  };

  return (
    <Button
      size={BUTTON_SIZE.compact}
      outlined={true}
      onClick={createRenewal}
      data-testid="discardRenewalButton"
      {...buttonProps}
    >
      Generate Renewal Quote
    </Button>
  );
};
